import script from "./DetalhesCreditoPedidoVenda.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalhesCreditoPedidoVenda.vue?vue&type=script&setup=true&lang=js"

import "./DetalhesCreditoPedidoVenda.vue?vue&type=style&index=0&id=e33abcb4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e33abcb4"]])

export default __exports__